import dayjs from "dayjs";
import { BRAND } from "../../types";

interface DateSelectorProps {
  /** 选中的出发日期 */
  selectedDate: string;
  /** 选中的返回日期（团游有固定日期段时传入） */
  endDate?: string;
  /** 行程天数 */
  days: number;
  /** 行程晚数 */
  nights: number;
  /** 是否只读（订单详情模式） */
  readOnly?: boolean;
  onModify?: () => void;
}

export function DateSelector({
  selectedDate,
  endDate,
  days,
  nights,
  readOnly = false,
  onModify,
}: DateSelectorProps) {
  const d = dayjs(selectedDate);
  const isValid = d.isValid();
  const returnDate = endDate ? dayjs(endDate) : (isValid ? d.add(days - 1, "day") : null);
  const displayDays = endDate ? returnDate.diff(d, "day") + 1 : days;
  const displayNights = endDate ? returnDate.diff(d, "day") : nights;

  return (
    <div className="rounded-2xl p-4" style={{ background: "#fff" }}>
      {/* 标题行 */}
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <div
            className="w-5 h-5 rounded flex items-center justify-center"
            style={{ background: BRAND }}
          >
            <i className="ri-calendar-line text-white" style={{ fontSize: 12 }} />
          </div>
          <span className="text-sm font-bold text-gray-900">出行日期</span>
        </div>
        {isValid && (
          <span className="text-xs px-2 py-0.5 rounded-full" style={{ color: BRAND, background: "#FFF7ED" }}>
            已选定日期
          </span>
        )}
      </div>

      {/* 内容行 */}
      <div className="flex items-center gap-3">
        {/* 左侧：日期徽标 */}
        <div
          className="w-14 h-14 rounded-xl flex flex-col items-center justify-center flex-shrink-0"
          style={{ background: "#FFF7ED" }}
        >
          <span className="text-xs font-medium" style={{ color: BRAND }}>
            {isValid ? d.format("MM月") : "--"}
          </span>
          <span
            className="text-xl font-bold leading-none mt-0.5"
            style={{ color: BRAND }}
          >
            {isValid ? d.format("DD") : "--"}
          </span>
        </div>

        {/* 中间：日期信息 */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-bold text-gray-900">
            {isValid ? d.format("YYYY年MM月DD日") : "请选择出行日期"}{" "}
            <span className="font-normal text-gray-500">出发</span>
          </div>
          {isValid && returnDate && (
            <div className="text-xs text-gray-400 mt-1">
              返回：{returnDate.format("YYYY-MM-DD")} · 共{displayDays}天{displayNights}晚
            </div>
          )}
        </div>

        {/* 右侧：修改按钮 */}
        {!readOnly && onModify && (
          <button
            onClick={onModify}
            className="px-4 py-1.5 rounded-full border text-sm cursor-pointer whitespace-nowrap"
            style={{
              borderColor: BRAND,
              color: BRAND,
              background: "#fff",
            }}
          >
            <i className="ri-edit-line mr-1" style={{ fontSize: 13 }} />
            修改
          </button>
        )}
      </div>
    </div>
  );
}

